export default {
  title: {
    en: 'today’s',
  },
  top: {
    en: 'Top',
  },
  events: {
    en: 'Events',
  },

  // Sports
  politics: {
    en: 'Politics',
  },
  football: {
    en: 'Football',
  },
  basketball: {
    en: 'Basketball',
  },
  cricket: {
    en: 'Cricket',
  },
  boxing: {
    en: 'Boxing',
  },
  'ice-hockey': {
    en: 'Ice Hockey',
  },
  'rugby-union': {
    en: 'Rugby Union',
  },
  'baseball': {
    en: 'Baseball',
  },
  'rugby-league': {
    en: 'Rugby League',
  },
  'american-football': {
    en: 'American Football',
  },
  mma: {
    en: 'MMA',
  },
  tennis: {
    en: 'Tennis',
  },
  'dota-2': {
    en: 'Dota 2',
  },
  csgo: {
    en: 'CS:GO',
  },
  cs2: {
    en: 'Counter-Strike 2',
  },
  lol: {
    en: 'League of Legends',
  },
  gamefi: {
    en: 'GameFi',
  },
  other: {
    en: 'Other',
  },
}
